/* import __COLOCATED_TEMPLATE__ from './tags.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();